// above this perceived brightness (0-255) white text stops being readable
const WHITE_TEXT_MAX_BRIGHTNESS = 200;

/**
 * Primary CTA style: merchant button color with white text, unless the
 * color is very light (the shared helper switches to black text too early,
 * e.g. for mid blues). Falls back to the spec's near-black.
 * @param {string} buttonColor hex color
 */
export function getPrimaryButtonStyle(buttonColor) {
  if (!buttonColor) {
    return "background: #111; color: #fff;";
  }

  const hex = buttonColor.replace("#", "");
  const full = hex.length === 3 ? hex.replace(/./g, "$&$&") : hex;
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(full.substring(i, i + 2), 16));
  const brightness = Math.sqrt(0.299 * r * r + 0.587 * g * g + 0.114 * b * b);

  return `background: ${buttonColor}; color: ${brightness > WHITE_TEXT_MAX_BRIGHTNESS ? "#000" : "#fff"};`;
}

const COLOR_ATTRIBUTE_NAMES = ["color", "colour"];

/**
 * Tells us if a variant attribute (e.g. "Color") should render as swatches
 * @param {{ name?: string, label?: string }} attribute
 */
export function isColorAttribute(attribute) {
  return [attribute?.name, attribute?.label].some((value) =>
    COLOR_ATTRIBUTE_NAMES.includes((value || "").trim().toLowerCase()),
  );
}

// softer tones for common names (raw CSS "red"/"blue" are very saturated)
const SWATCH_PALETTE = {
  black: "#111111",
  white: "#ffffff",
  gray: "#8a8f94",
  grey: "#8a8f94",
  red: "#b8261c",
  orange: "#e0701f",
  yellow: "#f2c230",
  green: "#2e7d4f",
  blue: "#2357a6",
  navy: "#1f2f57",
  purple: "#6b3fa0",
  pink: "#e46a9b",
  brown: "#7a4e2d",
  beige: "#e3d5b8",
};

/**
 * Resolves a CSS color for a swatch from the variant label (e.g. "Black", "Navy Blue").
 * Returns null when the browser doesn't recognize it as a color.
 * @param {string} label
 */
export function getSwatchColor(label) {
  const value = (label || "").trim().toLowerCase().replace(/\s+/g, "");

  if (SWATCH_PALETTE[value]) {
    return SWATCH_PALETTE[value];
  }

  if (!value || typeof CSS === "undefined" || !CSS.supports?.("color", value)) {
    return null;
  }

  return value;
}
